module.exports = __webpack_public_path__ + "img/send-offer-mobile-fr.de229a74.jpg";